// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"menu_dropdown__GiJNY","dropdown__toggle":"menu_dropdown__toggle__mpY5J","dropdown__menu":"menu_dropdown__menu__mvlaT","dropdown__item":"menu_dropdown__item__2OI3t"};